const RecorderTypes = {
  DESKTOP_APP: 'desktop_app',
  CHROME_EXTENSION: 'chrome_extension',
};

export default RecorderTypes;
